import StageLayout from '../stage-layout';
import { jsx as _jsx } from "react/jsx-runtime";

var ApiIntegration = function ApiIntegration(_ref) {
  var stage = _ref.stage,
      prospect = _ref.prospect;
  return /*#__PURE__*/_jsx(StageLayout, {
    stage: stage,
    prospect: prospect,
    "data-element": "StageLayout",
    "data-component": "ApiIntegration",
    "data-source-file": "index.tsx"
  });
};

export default ApiIntegration;